export default __webpack_public_path__ + "70c4834c66f700b639878e17c7be8775.png";